import { render, staticRenderFns } from "./QuestionBuilderAction.vue?vue&type=template&id=5ab4058f&scoped=true"
import script from "./QuestionBuilderAction.vue?vue&type=script&lang=ts"
export * from "./QuestionBuilderAction.vue?vue&type=script&lang=ts"
import style0 from "./QuestionBuilderAction.vue?vue&type=style&index=0&id=5ab4058f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab4058f",
  null
  
)

/* custom blocks */
import block0 from "./QuestionBuilderAction.vue?vue&type=custom&index=0&blockType=comments"
if (typeof block0 === 'function') block0(component)

export default component.exports